import React, { useEffect, useState } from 'react';
import { useAppSelector } from '../../store/storeTypes';
import Cross from '../shared/Cross';
import { useConfig } from '../../helpers/useConfig';

export const MakeItAMealChoiceModal = ({ state, onClose, isMobileModal }) => {
  const config = useConfig();
  const brand = config?.BRAND;
  const bundles = useAppSelector(state => state.menu.bundles);
  const [bundle, setBundle] = useState();

  useEffect(() => {
    if (bundles && state.bundleName) {
      setBundle(bundles.find(b => b.name === state.bundleName));
    }
  }, [state.bundleName, state.selectedPizza, bundles])

  useEffect(() => {
  }, [])

  const handleConfirm = () => {
    state.resolve(true);
    onClose();
  };

  if (!bundle) { return <></> };

  return (
    <div className='miam-choice-modal'>
      {!isMobileModal &&
        <Cross closeWhiteCross onClick={onClose} absolute rightPosition={16} topPosition={16} />
      }
      <img className='bundle-image' src={bundle?.imageUrl} alt='food item' />
      <div className='title-container'>
        <h1 className='header' data-testid='closeiframe-modal-heading'>
          MAKE IT A MEAL?
        </h1>
        <div className='bundle-name-cost-container'>
          {(() => {
            if (!bundle.name) return <p />;
            const words = bundle.name.split(' ');
            if (words.length < 3) return <p>{bundle.name}</p>;
            const lastTwo = words.slice(-2).join('\u00A0');
            const first = words.slice(0, -2).join(' ');
            return <p>{first} {lastTwo}</p>;
          })()}
          <p>{brand === 'PE' ? '£' : '€'}{bundle.basePrice.toFixed(2)}</p>
        </div>
        <p>{bundle.description}</p>
      </div>
      <div className='option-container'>
        <button className='btn btn-primary option-btn' onClick={handleConfirm} >Make it a meal</button>
        <button className='btn btn-secondary option-btn' onClick={onClose} >No thanks</button>
      </div>
    </div>
  );
};
